<template>
  <div class="c-fold-out">
    <div class="c-fold-out__overlay" @click="toggleFlyIn"></div>
    <div class="c-fold-out__container">
      <div class="c-fold-out__filter-title">{{ $label('filters') }}</div>
      <div class="c-fold-out__filter-active">
        {{
          `${$label('activeFilters')} ${
            getActiveFitlers.length > 0 ? `(${getActiveFitlers.length})` : ``
          }`
        }}
      </div>
      <div class="c-fold-out__filters">
        <div v-if="getActiveFitlers.length > 0">
          <div v-for="filter in getActiveFitlers" :key="filter.key">
            <span>
              {{ filter.label }}: <b>{{ filter.value }}</b>
            </span>
            <button
              @click="removeActiveFilter(filter)"
              class="c-fold-out__filter-cross"
            >
              X
            </button>
          </div>
          <button
            @click="removeActiveFilters"
            class="c-filter-foldout__remove-filters"
          >
            {{ $label('clearfilter') }}
          </button>
        </div>
        <span v-else>{{ $label('noActiveFilters') }}</span>
      </div>

      <div v-for="filter in filters" :key="filter.label" :id="filter.anchor">
        <PriceFilter v-if="filter.type === 'price'" v-bind="filter" />
        <component
          v-else
          :is="filterType(filter.type)"
          :selectedValue="getSelectedId(filter.values)"
          @onChanged="onChangeFilter"
          v-bind="filter"
        />
      </div>
      <div class="c-fold-out__button-cta">
        <MyButton
          :label="`${$label('showResultsLabel')} (${this.totalResults})`"
          :click-callback="toggleFlyIn"
        />
      </div>
    </div>
  </div>
</template>

<script>
import MyButton from '@/components/Utilities/Button.vue'
import Icon from '@/components/Utilities/Icon'
import PriceFilter from '@/components/Filter/PriceFilter.vue'
import CheckboxFilter from '@/components/Filter/CheckboxFilter.vue'
import RadioFilter from '@/components/Filter/RadioFilter.vue'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'FlyIn',
  components: { Icon, MyButton, PriceFilter },
  data() {
    return {
      filters: global.vesteda.settings.filters,
    }
  },
  computed: {
    ...mapState(['filter']),
    ...mapGetters(['totalResults', 'unitResults']),
    getActiveFitlers() {
      var activeFilters = []

      // loop through all possible filters
      this.filters.map((filter) => {
        // check if fitlers query parameters has active value of the specific filter
        this.getSelectedValue(filter.values).map((value) => {
          activeFilters.push({
            id: value.id,
            key: `active-${filter.label}-${value.label}`,
            label: filter.label,
            value: value.label,
          })
        })
      })

      // check if price change from the default 500 - 9999 price range
      if (this.filter.priceFrom !== 500) {
        activeFilters.push({
          id: 'priceFrom',
          key: `active-priceFrom`,
          label: `${this.$label('price')} ${this.$label('from')}`,
          value: `€${this.filter.priceFrom},-`,
        })
      }
      if (this.filter.priceTo !== 9999) {
        activeFilters.push({
          id: 'priceTo',
          key: `active-priceTo`,
          label: `${this.$label('price')} ${this.$label('to')}`,
          value: `€${this.filter.priceTo},-`,
        })
      }

      // make amount of active filter availible for parent component
      this.$emit('getAmountActiveFitlers', activeFilters.length)

      return activeFilters
    },
  },
  methods: {
    toggleFlyIn() {
      this.$store.dispatch('toggleFlyIn');
      localStorage.setItem('last_interacted', 'Filter update');
    },
    filterType(type) {
      switch (type) {
        case 'radio button':
          return RadioFilter
        case 'checkbox':
          return CheckboxFilter
        default:
          return null
      }
    },
    onChangeFilter(value) {
      this.$store.dispatch('updateFilters', value)
      this.$store.dispatch('getUnits')
    },
    getSelectedId(values) {
      return values
        .filter((value) => this.filter.filters.includes(value.id))
        .map((value) => value.id)
    },
    getSelectedValue(values) {
      return values.filter((value) => this.filter.filters.includes(value.id))
    },
    removeActiveFilter(filter) {
      if (Number.isInteger(filter.id)) {
        this.onChangeFilter({ remove: filter.id })
      } else {
        if (filter.id === 'priceFrom') {
          this.$store.commit('UPDATE_PRICE_FROM', 500)
        } else if (filter.id === 'priceTo') {
          this.$store.commit('UPDATE_PRICE_TO', 9999)
        }
        this.$store.dispatch('getUnits')
      }
    },
    removeActiveFilters() {
      this.$store.dispatch('clearFilters')
    },
  },
}
</script>

<style scoped>
.c-fold-out__button-close {
  align-self: flex-end;
}

.c-fold-out.is-open {
  left: 0;
}

.c-fold-out__container {
  background-color: white;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-block-start: var(--base-spacing-unit);
  padding-inline: var(--base-spacing-unit);
  position: fixed;
  left: 0;
  min-height: 100vh;
  overflow-y: scroll;
  top: 0;
  z-index: 999;
}

.c-fold-out__overlay {
  background-color: black;
  position: fixed;
  width: 100%;
  height: 100vh;
  opacity: 30%;
  inset: 0;
  z-index: 999;
}

.c-fold-out__button-cta {
  background-color: white;
  bottom: 0;
  display: flex;
  flex-direction: column;
  padding-block: var(--base-spacing-unit);
  position: sticky;
}

.c-fold-out__filter-title {
  font-weight: bolder;
  margin-bottom: 1.5rem;
  font-size: 1.5em;
}

.c-fold-out__filters {
  font-size: 0.875rem;
  margin-bottom: 2rem;
}

.c-fold-out__filter-cross {
  float: right;
  font-weight: bolder;
}

.c-fold-out__filter-active {
  font-weight: bolder;
  margin-bottom: 0.5rem;
}

/* Until lap */
@media (max-width: 36.24em) {
  .c-fold-out__container {
    width: 100%;
  }
}

/* From lap */
@media (min-width: 36.25em) {
  .c-fold-out__container {
    width: 350px;
  }
}
</style>
